import ProductBox from './productBox'

export default ProductBox
